// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__1Cloc","disabled":"Link_disabled__3H4oX","highlighted":"Link_highlighted__2VQq2","strikethrough":"Link_strikethrough__2f1wx"};